"use client";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { captureArrival, sendPendingArrival } from "@/lib/arrival";
import { capturarAtribuicao } from "@/lib/attribution";
import { capturePartnerRef } from "@/lib/partner-referral";

/**
 * Grava a origem da PRIMEIRA visita (CHAT002-2375).
 *
 * Antes, a origem só existia se o usuário caísse direto em
 * `/auth/register?utm_source=...`: a página lia os `searchParams` e pronto. Quem
 * chegava por um anúncio na home e navegava até o cadastro perdia a atribuição
 * inteira — que é o caminho mais comum.
 *
 * Reage à query string, não à rota: origem só chega por parâmetro de URL (ou
 * pelo referrer, que a primeira montagem já cobre). `capturarAtribuicao` é
 * idempotente e nunca sobrescreve o first touch, então o custo é um `getItem`.
 */
export function AttributionCapture() {
	const searchParams = useSearchParams();

	useEffect(() => {
		capturarAtribuicao(searchParams.toString());
		// O link do parceiro (CHAT002-5233, parte 5), `?p=CODIGO`: o último vale.
		capturePartnerRef(searchParams.toString());
		// A chegada por anúncio ou link com origem vira evento, com ou sem login
		// (CHAT002-5673). Uma que ficou sem resposta na página anterior vai agora.
		captureArrival(searchParams.toString());
		void sendPendingArrival();
	}, [searchParams]);

	return null;
}
